/** Shell / ops: dashboard, accounts, users, admins, overview, reports, settings. */
export default [

  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/private/DashboardView.vue'),
    meta: {
      public: false,
      title: 'Dashboard',
    },
  },

  {
    path: '/admins',
    name: 'Admins',
    component: () => import('@/views/private/AdminsView.vue'),
    meta: {
      public: false,
      title: 'Admins',
    },
  },

  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/private/UsersView.vue'),
    meta: {
      public: false,
      title: 'Users',
    },
  },

  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('@/views/private/AccountsView.vue'),
    meta: {
      public: false,
      title: 'Accounts',
    },
  },

  {
    path: '/overview',
    name: 'Overview',
    component: () => import('@/views/private/OverviewView.vue'),
    meta: {
      public: false,
      title: 'Overview',
    },
  },

  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/private/ReportsView.vue'),
    meta: {
      public: false,
      title: 'Reports',
    },
  },

  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/private/SettingsView.vue'),
    meta: {
      public: false,
      title: 'Settings',
    },
  },

];
